export default __webpack_public_path__ + "static/cafe_36062-cdb68dfd36ff871a41a45b03149a04a9.png";